module.exports = __webpack_public_path__ + "static/bechtle-60035e9a52cfc9c7b64e556337b292a3.png";